<template>
  <li>
    <SyllabusItem v-if="searchType == 'studieplan'" :hit="hit"></SyllabusItem>
    <PersonalItem
      v-else-if="this.hit.typeName == 'epiumu.models.pages.personalsida'"
      :hit="hit"
      :texts="texts"
    ></PersonalItem>
    <UtbildningItem
      v-else-if="this.hit.typeName == 'cms.models.blocks.utbildning.programblock' 
      || this.hit.typeName == 'cms.models.blocks.utbildning.kursblock' 
      || this.hit.typeName == 'cms.models.blocks.utbildning.kurspaketblock'"
      :hit="hit"
      :texts="texts"
    ></UtbildningItem>
    <ValkomstInfoItem
      v-else-if="this.hit.typeName == 'cms.models.blocks.student.valkomstinformationblock'"
      :hit="hit"
      :texts="texts"
    ></ValkomstInfoItem>
    <PersonanpassadItem
      v-else-if="
        this.hit.typeName ==
        'student.models.pages.personanpassadinformationssida'
      "
      :hit="hit"
      :texts="texts"
      :showBreadcrumb="showBreadcrumb"
    ></PersonanpassadItem>
    <GenericItem
      v-else
      :hit="hit"
      :texts="texts"
      :showBreadcrumb="showBreadcrumb"
    ></GenericItem>
  </li>
</template>
<script>
import GenericItem from "./items/genericitem.vue";
import PersonalItem from "./items/personalitem.vue";
import SyllabusItem from "./items/syllabusitem.vue";
import PersonanpassadItem from "./items/personanpassaditem.vue";
import UtbildningItem from "./items/utbildningitem.vue";
import ValkomstInfoItem from "./items/valkomstinfoitem.vue";
export default {
  name: "SearchResultItem",
  props: {
    hit: Object,
    texts: Object,
    searchType: String,
    showBreadcrumb: Boolean,
  },
  components: {
    GenericItem,
    PersonalItem,
    SyllabusItem,
    PersonanpassadItem,
    UtbildningItem,
    ValkomstInfoItem,
  },
};
</script>
